export const DOMAIN_NAME = "3HJOBS";

export const NAIRA = "₦";

export const USER_NAV_BAR_MENUS = [
  { name: "Projects", to: "/projects" },
  { name: "About", to: "/about" },
  { name: "FAQ", to: "/faq" },
];

export const FOOTER_NAV_BAR_MENUS = [
  { name: "Projects", to: "/projects" },
  { name: "About", to: "/about" },
  { name: "Contact Us", to: "/contact" },
  { name: "FAQ", to: "/faq" },
];
